<template>
	<div
		v-if="filters"
		class="products__categories-item"
	>
		<a
			class="products__categories-item-link products-filter__trigger"
			@click.prevent="toggleOverlay"
		>
			<div class="products__categories-item-inner">
				<span
					class="products__categories-item-badge"
					v-html="filtersActive.length"
					v-if="filtersActive.length"
				/>
				<SVGFilter
					class="products__categories-item-icon"
				/>
				<span
					class="products__categories-item-text"
					v-html="$t('shoplist.filter.iconLabel')"
				/>
			</div>
		</a>
		<div
			class="products-filter"
		>
			<div class="products-filter__wrapper">
				<div class="products-filter__header">
					<h3
						class="products-filter__title"
						v-html="$t('shoplist.filter.title')"
					/>
					<button
						class="products-filter__close"
						@click.prevent="closeOverlay"
					>
						<SVGClose/>
					</button>
				</div>

				<div
					class="products-filter__group"
					v-for="filter in filtersEnhanced"
					:key="filter.title"
				>
					<h4
						class="products-filter__group-title"
						v-html="filter.title"
					/>
					<label
						class="products-filter__option"
						v-for="option in filter.options"
						:key="option.id"
					>
						<input
							type="checkbox"
							class="products-filter__option-input"
							:value="option.id"
							:checked="option.active"
							@change="onChange(option, $event.target.checked)"
						>
						<span
							class="products-filter__option-label"
							v-html="option.label || option.id"
						/>
					</label>
				</div>
				<Button
					v-if="filtersActive.length"
					class="products-filter__reset"
					:text="$t('shoplist.filter.resetButton')"
					type="button"
					level="tertiary"
					arrow
					@click.prevent="onResetFilters"
			/>
			</div>
		</div>
	</div>
</template>

<script>
import htmlComponent from 'htmlcomponent'
import GenericMixin from '@/mixins/GenericVueMixin';
import OverlayMixin from '@/mixins/OverlayVueMixin';
import Button from '@/components/Button';

export default {
	mixins: [
		GenericMixin,
		OverlayMixin,
	],
	components: {
		Button
	},
	props: {
		overlayType: {
			type: String,
			default: 'products-filter'
		},
		filters: {
			type: Array,
			default: []
		},
		filtersActive: {
			type: Array,
			default: Array,
		}
	},
	data() {
		return {
			opened: false,
		};
	},
	computed: {
		filtersEnhanced() {
			const filters =  this.filters
				.reduce((p, c) => {
					if (!p[c.group]) {
						p[c.group] = {
							title: c.group,
							options: []
						}
					}
					p[c.group].options.push({...c})
					return p
				}, {})
			return Object.values(filters)
		}
	},
	methods: {
		onResetFilters() {
			this.filtersActive.forEach(filter => {
				this.$emit('change', filter, false);
			});
			this.overlayIgnoreScrollPos = true;
		},
		onChange(option, active) {
			this.$emit('change', option.id, active);
			this.overlayIgnoreScrollPos = true;
		},
		afterOverlayClose() {
			this.overlayIgnoreScrollPos = false;
		}
	}
}
</script>

<style>

</style>
